import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { faqs } from '../data/mock';

export const FAQSection = () => {
  return (
    <section id="faq" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-emerald-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Get answers to common questions about trademark registration, the USPTO process, and protecting your brand.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="border-2 border-emerald-200 rounded-lg px-6 hover:border-amber-500 transition-colors duration-300"
              >
                <AccordionTrigger className="text-left text-lg font-semibold text-emerald-900 hover:text-amber-700 py-6">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-700 leading-relaxed pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          <div className="mt-12 bg-gradient-to-r from-emerald-50 to-amber-50 rounded-xl p-8 text-center border-2 border-emerald-200">
            <h3 className="text-2xl font-bold text-emerald-900 mb-3">
              Still Have Questions?
            </h3>
            <p className="text-gray-700 mb-6">
              Our trademark experts are here to help. Schedule a free consultation to discuss your specific needs and get personalized guidance.
            </p>
            <a
              href={`mailto:info@claimatrademark.com`}
              className="inline-block bg-emerald-700 hover:bg-emerald-800 text-white font-semibold px-8 py-3 rounded-lg transition-all duration-300"
            >
              Contact Our Experts
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
